import _ from "lodash"
import type { DarkAndLight } from "./ColorSchemes"

const imageContext = require.context("@images", false, /\.(png|svg)$/)
const imageKeys = imageContext.keys()

function getImage(filename: string): string {
  const svgKey = `./${filename}.svg`
  const pngKey = `./${filename}.png`

  if (imageKeys.includes(svgKey)) { return imageContext(svgKey) }
  if (imageKeys.includes(pngKey)) { return imageContext(pngKey) }

  throw new Error(`Image not found: ${filename}`)
}

const THEMED_IMAGE_NAMES = [
  "arrow__buttonDown",
  "arrow__questionBack--v2",
  "arrow__questionBack",
  "arrowLink__arrow",
  "checkbox__checkmark",
  "icon__multiselectRevealCorrect",
  "icon__check",
  "icon__facebook",
  "icon__happy--0",
  "icon__happy--1",
  "icon__happy--2",
  "icon__happy--3",
  "icon__happy--4",
  "icon__happy--5",
  "icon__magazinFalsch1",
  "icon__magazinFalsch2",
  "icon__magazinFalsch3",
  "icon__magazinHappy1",
  "icon__magazinHappy2",
  "icon__magazinHappy3",
  "icon__magazinCheck",
  "icon__magazinQuestion",
  "icon__mail",
  "icon__sad--0",
  "icon__sad--1",
  "icon__sad--2",
  "icon__sad--3",
  "icon__sad--4",
  "icon__sad--5",
  "icon__soso",
  "icon__twitter",
  "icon__whatsapp",
  "loadingSpinner",
] as const

export const THEMED_IMAGES: Record<string, DarkAndLight> =
  _.fromPairs(THEMED_IMAGE_NAMES.map((imgName) => {
    return [imgName, {
      light: `url(${getImage(imgName)})`,
      dark: `url(${getImage(imgName + "--dark")})`,
    }]
  }))
